import styled from 'styled-components';

export const Count = styled.h5`
  text-align: center;
  color: ${props => props.theme.colors.white};
  margin: 0;
`;
